import styled from "styled-components";

export const MainDiv = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  justify-content: space-between;
`;
export const ColumnDiv = styled.div`
  width: 426px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const InformationDiv = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  gap: 8px;
`;
export const InformationTitle = styled.p`
  margin-bottom: 20px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const InputDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;
export const InputLabel = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const InputField = styled.div`
  padding: 4px 8px;
  width: 233px;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #c8c8c8;
  background-color: #e2e2e2;
`;
export const InputValue = styled.p`
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
